<template>
   <div class="autocomplete">
     <div class="auto-result">{{firstResult.value}}</div>
    <input class="auto-input" type="text" :placeholder="plcHolder" @input="onChange" v-model="search" @keyup.down="onArrowDown" @keyup.up="onArrowUp" @keyup.enter="onEnter" />
    <ul id="autocomplete-results" v-show="results.length > 0" class="autocomplete-results">
      <li class="loading" v-if="isLoading">
        {{loadText}}
      </li>
      <li v-else v-for="(result, i) in results" :key="i" @click="setResult(result)" class="autocomplete-result" :class="{ 'is-active': i === arrowCounter }">
        {{ result.value }}
      </li>
    </ul>
    <ul id="autocomplete-results" v-show="isUnavailable" class="autocomplete-results">
      <li class="loading" >
        {{noResText}}
      </li>
    </ul>


  </div>
</template>

<script>
export default {
  name: "autocomplete",
  template: "#autocomplete",
  props: {
    items: {
      type: Array,
      required: false,
      default: () => []
    },
    isAsync: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      results: [],
      search: "",
      isLoading: false,
      arrowCounter: -1,
      firstResult : "",
      plcHolder : "pretražite rezultate",
      loadText : "Učitava se...",
      noResText : "Nema dostupnih osoba."
    };
  },

  methods: {
    onChange() {
      // Let's warn the parent that a change was made
      this.$emit("input", this.search);

      // Is the data given by an outside ajax request?
      if (this.isAsync) {
        this.isLoading = true;

      } else {
        // Let's search our flat array
        this.filterResults();
        this.isOpen = true;
      }
    },

    filterResults() {
        // first uncapitalize all the things
        this.results = []
        var tmpResults = this.items.filter(item => {
          return item.value.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
        });
        var sideRes = []

        if(tmpResults.length > 0){
          //usklađivanje s početnim 
          tmpResults.forEach(p=>{
            if(p.value.toLowerCase().startsWith(this.search.toLowerCase())){
              this.results.push(p)
            }else{
              sideRes.push(p)
            }
          })
          this.results = this.results.concat(sideRes)
          this.firstResult = this.results[0]
        }else{
          this.firstResult = ""
        }
        if(this.search === "")
        {
          this.results = []
          this.firstResult = ""
        }
    },
    setResult(result) {
      this.search = result.value;
      this.firstResult = result
      this.isOpen = false;
    },
    onArrowDown(evt) {
      if ((this.arrowCounter + 1) < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
        this.firstResult =this.results[this.arrowCounter]
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
        this.firstResult =this.results[this.arrowCounter]

      }
    },
    onEnter() {
      if(this.search !== "" && this.arrowCounter === -1)
      {
        this.arrowCounter = 0;
      }
      if(this.results.length > 0){
        this.search = this.results[this.arrowCounter].value;
        this.isOpen = false;
        var link = this.results[this.arrowCounter].link;
        this.arrowCounter = -1;
        
      }
      
    },
    handleClickOutside(evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false;
        this.arrowCounter = -1;
      }
    }
  },
  watch: {
    items: function(val, oldValue) {
      // actually compare them
      if (val.length !== oldValue.length) {
        this.results = val;
        this.isLoading = false;
      }
    }
  },
  computed:{
    isUnavailable()
    {
      return ((this.search !== "") && (this.results.length === 0)) 
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    //definiranje jezika teksta
    if(this.$route.path.includes("/en"))
    {
      this.plcHolder = "search documents"
      this.loadText = "Loading results..."
      this.noResText = "There is no available documents."
    }
  },
  destroyed() {
    document.removeEventListener("click", this.handleClickOutside);
  }

}
</script>

<style>

</style>